import Box from '@mui/material/Box';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import Typography from '@mui/material/Typography';
import { GRADIENT_WARM } from '../../styles/tokens';

const FEATURES = [
	'Download patterns instantly',
	'Create custom patterns using any image',
	'Support for both cm and inches',
	'User-friendly program makes pattern creation simple',
	'Try before subscribing with single pattern purchases',
	'Handle unnumbered book pages',
	'Create unlimited patterns with flexible payment options',
	'Cancel anytime with no commitments',
	'Makes a thoughtful and creative gift',
	'Save ink with ink-saver strip options',
	'Create stunning lenticular patterns',
	'Easy-to-follow patterns for all skill levels',
];

export const FeatureList = () => {
	return (
		<div style={{ marginBottom: '80px', marginTop: '80px' }}>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					gap: '1rem',
				}}
			>
				<Typography
					variant="h2"
					style={{
						textAlign: 'center',
						lineHeight: '42px',
						marginBottom: '20px',
					}}
				>
					Pattern creation made{' '}
					<span
						style={{
							background: GRADIENT_WARM,
							WebkitBackgroundClip: 'text',
							WebkitTextFillColor: 'transparent',
						}}
					>
						easy
					</span>
				</Typography>
			</div>
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					padding: '1rem',
				}}
			>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						gap: '1rem',
					}}
				>
					{FEATURES.map((feature) => (
						<Box
							key={feature}
							sx={{
								py: 0.5,
								display: 'flex',
								gap: 1.5,
								alignItems: 'center',
							}}
						>
							<CheckCircleRoundedIcon
								sx={{ width: 40, color: 'primary.main' }}
							/>
							<Typography
								variant="h5"
								component={'span'}
								sx={{ color: 'text.primary' }}
							>
								{feature}
							</Typography>
						</Box>
					))}
				</div>
			</div>
		</div>
	);
};
